<template>
    <div>
        <el-popover
            popper-class="gourp-edit"
            style="padding: 0px"
            placement="bottom-start"
            width="200"
            v-model="isPopoverShow"
            @click.native.stop
            trigger="click">
            <ul>
                <li v-if="isDisable" style="cursor: not-allowed; color: #ddd;"  @click="openDialog">添加分组(最多10个)</li>
                <li v-else @click="openDialog">{{mode === 'editGroup' ? '编辑分组' : '添加分组'}}</li>
            </ul>
            <i slot="reference" class="iconfont icongengduoda" @click="hide"></i>
            <make-group ref="makeGroup" @groupSuccess="groupSuccess"></make-group>
        </el-popover>
    </div>
</template>

<script>
import MakeGroup from './make_group.vue'
import { openMessage, openRenewMessage } from '@/utils/system.tsx'
import { editionJudge } from '../../../../utils/editionJudge'

export default {
    data() {
        return {
            isPopoverShow: false
        }
    },

    props: {
        mode: {
            type: String,
            default: 'editGroup'
        },

        groupInfo: {
            type: Object,
            default: () => { return {} }
        },

        groupNum: {
            type: Number,
            default: 1
        }
    },

    computed: {
        isDisable() {
            return this.mode !== 'editGroup' && this.groupNum >= 10
        }
    },

    methods: {
        openDialog() {
            if (this.isDisable) {
                return
            }
            if (this.mode !== 'editGroup') {
                if (editionJudge.isBiaoZhun && this.groupNum >= 1) {
                    return openRenewMessage('标准版无法添加一级分组，如需添加，请升级至更高版本')
                }
                if (editionJudge.isZhuanYe && this.groupNum >= 5) {
                    return openRenewMessage('专业版最多可添加5个一级分组，如需添加更多分组，请升级为旗舰版')
                }
            }
            this.hide()
            this.$refs.makeGroup.open({
                mode: this.mode,
                groupInfo: this.groupInfo,
            })
            this.hide()
        },

        groupSuccess(mode) {
            this.$emit('groupSuccess', mode)
        },

        // 通过JS 关闭Popover
        hide() {
            document.getElementById('app').click()
        }
    },

    components: {
        MakeGroup
    }
}
</script>

<style lang="scss">

.gourp-edit {
    padding: 6px 0px !important;
    width: 108px !important;

    ul {
        li {
            padding-left: 8px;
            height: 36px;
            line-height: 36px;
            font-size: 14px;
            color: #333333;
            cursor: pointer;

            &:hover {
                background: #F5F5F5;
            }
        }
    }
}

.icongengduoda {
    // display: none;
    color: #888888;
    margin-right: 8px;
    font-size: 14px;
}
</style>
